<template>
  <b-sidebar
    v-if="isSidebarActive"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm()"
    @change="updateIsSidebarActive($event)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Plant Detail
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide" />
      </div>

      <!-- BODY -->
      <ValidationObserver
        #default="{ handleSubmit }"
        ref="TicketPlantDetailForm">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm()">
          <TextFieldInput
            v-model="ticketPlant.code"
            name="code"
            label="Code"
            :rules="{ required: true }"
            trim
            @input="covertUpperCase($event)"
          />
          <TextFieldInput
            v-model="ticketPlant.name"
            name="Name"
            label="Name"
            :rules="{ required: true, max: 50 }"
            trim />
          <TextFieldInput
            v-model="ticketPlant.remark"
            name="Remark"
            label="Remark"
            trim />
          <StatusRadioButton :status.sync="ticketPlant.status" />
          <b-row>
            <b-col>
              Created At : {{ ticketPlant.createdAt | formatDateTimeEn }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Created By : {{ ticketPlant.createdBy.username }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Updated At : {{ ticketPlant.updatedAt | formatDateTimeEn }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Updated By : {{ ticketPlant.updatedBy.username }}
            </b-col>
          </b-row>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 btn-submit"
              type="submit"
              :disabled="compareOldValue">
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              class="btn-submit"
              variant="outline-secondary"
              :disabled="compareOldValue"
              @click="resetForm()">
              Cancel
            </b-button>
            <b-button
              variant="outline-danger"
              class="btn-icon ml-auto"
              :disabled="!compareOldValue"
              @click="deleteItem()">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </b-sidebar>
</template>

<script>
import TextFieldInput from '@/components/Form/TextFieldInput.vue'
import StatusRadioButton from '@/components/Form/StatusRadioButton.vue'

export default {
  components: { TextFieldInput, StatusRadioButton },
  model: {
    prop: 'isSidebarActive',
    event: 'update:is-sidebar-active'
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      default: false
    },
    initialTicketPlant: {
      type: Object,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ticketPlant: {
      get () {
        return this.selectedItem
      },
      set (val) {
        this.$emit('update:selected-item', val)
      }
    },
    compareOldValue () {
      return JSON.stringify(this.ticketPlant) === JSON.stringify(this.initialTicketPlant)
    }
  },
  methods: {
    updateIsSidebarActive (val) {
      this.$emit('update:is-sidebar-active', val)
    },
    onSubmit () {
      const payload = {
        code: this.ticketPlant.code,
        id: this.ticketPlant.id,
        name: this.ticketPlant.name,
        remark: this.ticketPlant.remark,
        status: this.ticketPlant.status
      }
      this.$emit('update-ticket-plant', payload)
    },
    resetForm () {
      this.ticketPlant = { ...this.initialTicketPlant }
      this.$refs.TicketPlantDetailForm.reset()
    },
    deleteItem () {
      this.$emit('delete-item', {
        ID: this.ticketPlant.id,
        Name: this.ticketPlant.name
      })
    },
    covertUpperCase (e) {
      if (e) {
        this.ticketPlant.code = e.toUpperCase()
      }
    }
  }
}
</script>

<style>

</style>
